import axios, { isAxiosError } from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2"

const LIMIT = 20

const CuratorVideos = ({ }) => {

  const userLoggedIn = useSelector(state => state.userLoggedIn)
  const navigate = useNavigate()

  const [uploading, setUploading] = useState(false)
  const [page, setPage] = useState(1)
  const [videos, setVideos] = useState([])
  const [count, setCount] = useState(0)

  const deleteFiles = () => {

    const imageInput = document.querySelector(`#image-upload`)
    if (imageInput) {
      imageInput.value = ""
    }
  }

  const updateData = (value) => {
    let requestBody;
    requestBody = new FormData()
    requestBody.set('image', value)
    requestBody.set('isvideo', true)
    setUploading(true)
    axios.post(`/images-meta-api/videos/upload-new`, requestBody).then(response => {
      const id = response.data.id
      window.open('/video-data/' + id, '_blank')
      deleteFiles()
    }).finally(() => {
      setUploading(false)
    })
  }

  const uploadImage = () => {
    const imageInput = document.querySelector(`#image-upload`)
    if (!imageInput.files || imageInput.files.length == 0) {
      Swal.fire({ title: "No Image Selected", text: "Select an image to upload", timer: 1000 })
      return
    }
    const file = imageInput.files[0]
    updateData(file)
  }

  const getVideos = async (signal) => {
    try {
      const response = await axios.get(`/images-meta-api/videos/get-videos?page=${page}&limit=${LIMIT}`, { signal })
      setVideos(response.data.videos)
      setCount(response.data.count)
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
      }
    }
  }



  useEffect(() => {
    if (!userLoggedIn || !userLoggedIn.curator) {
      navigate('/')
    }
    const abortController = new AbortController()
    getVideos(abortController.signal)
    return () => {
      abortController.abort()
    }
  }, [page])

  return <div>
    <div className="fixed top-4 bg-white">
      <div className="px-1 flex justify-center items-center m-1 w-screen pt-10">
        <div className="p-8 border rounded m-2 w-3/4">
          <input
            id={'image-upload'}
            type='file'
            accept="video/*"
          />
          <button className="primary-btn" onClick={() => {
            uploadImage()

          }}
            disabled={uploading}
          >UPLOAD</button>
        </div>

      </div>
      <div className="flex justify-center">
      </div>
    </div>
    <div
      className="flex flex-wrap mt-40 border-t-2 border-t-slate-500"
    >{
        videos.map(vid => <div className="w-1/4 p-1 border">
          <video
            src={vid.imageUrl}
            controls
          />
          <div className="w-full">
            <a
              href={`video-data/${vid._id}`}
              className='bg-blue-500 rounded text-white my-1 w-full m-1 block text-center'
              target={'_blank'}
            >Update Data</a>
          </div>
        </div>)
      } </div>
  </div>

}

export default CuratorVideos
